import IdeaIcon from '../../components/ui/icons/widgets/Idea';
import Document from '../../components/ui/icons/widgets/Document';

const ToolBarInstruction = () => {
	return (
		<div className="dynamic-medium text-[#6D7D86] py-10 px-5 border-dashed border border-[#5D9BFD] rounded-xl divide-y">
			<div className="pb-4 font-medium">
				Use the <span className="text-[#E861C9]">toolbar above</span> to enrich
				your section
				<br />
			</div>

			<div className="grid w-full grid-cols-12 py-4 text-sm xl:text-base 2xl:text-lg">
				<span className="col-span-4 m-auto">Click to add</span>
				<div className="col-span-2 m-auto">
					<IdeaIcon />
				</div>
				<div className="col-span-6 pl-2">
					<h4 className="font-medium">
						Ideas let the ai incorporate them in the proposal.
					</h4>
					<p className="mt-2 dynamic-text">
						Think of it as a useful prompt to the ai
					</p>
				</div>
			</div>
			<div className="grid w-full grid-cols-12 py-4 text-sm xl:text-base 2xl:text-lg">
				<span className="col-span-4 m-auto">Click to add</span>
				<div className="col-span-2 m-auto">
					<Document />
				</div>
				<div className="col-span-6 pl-2">
					<h4 className="font-medium">
						Documents are read by the ai and used to make suggestions.
					</h4>
					<p className="mt-2 dynamic-text">
						{' '}
						You will see these when you click suggest in write
					</p>
				</div>
			</div>
		</div>
	);
};

export default ToolBarInstruction;
